import onNavbarLoad from './navbar';
import onHeaderBannerLoad from './header-banner';
import onCardsModuleLoad from './cards-module';
import onLeadreshipModuleLoad from './leadership';
import onTestimonialsLoad from './testimonials-carousel';
import onLoanCalculatorLoad from './loan-calculator';
import onSimpleCalculatorLoad from './simple-calculator';
import onFeaturesListLoad from './features-list';
import onFormLoad from './form';
import onShoppingNetworkLoad from './shopping-network';
import onPromotedItemsLoad from './promoted-item';
import onPromoSectionLoad from './promo-section';
import onMediaLoad from './media';
import onMediaDetailsLoad from './media-details';
import onSearchResultsLoad from './search-results';
import onProductQualificationLoad from './product-qualification';
import onFAQLoad from './faq';
import onGenerateContentLoad from './general-content';
import onLegalLoad from './legal';
import onAccordionsLoad from './accordion';
import onFooterLoad from './footer';
import onTabsContainerLoad from './tabsContainer';
import onGridWrapperLoad from './gridWrapper';
import onWindowLoad from './scrollHandler';
import onMaintenanceBannerLoad from './maintenance-banner';

const init = () => {
  onWindowLoad();
  onNavbarLoad();
  onFooterLoad();
  onHeaderBannerLoad();
  onCardsModuleLoad();
  onLeadreshipModuleLoad();
  onTestimonialsLoad();
  onLoanCalculatorLoad();
  onFeaturesListLoad();
  onFormLoad();
  onShoppingNetworkLoad();
  onPromoSectionLoad();
  onPromotedItemsLoad();
  onMediaLoad();
  onMediaDetailsLoad();
  onSearchResultsLoad();
  onMaintenanceBannerLoad();
  onProductQualificationLoad();
  onFAQLoad();
  onGenerateContentLoad();
  onLegalLoad();
  onAccordionsLoad();
  onSimpleCalculatorLoad();
  onTabsContainerLoad();
  onGridWrapperLoad();
};

window.addEventListener('DOMContentLoaded', init);
